import { useContext } from "react";
import { Context } from "Context";
import Button from "components/shared/Button";
import LottieAnimation from "components/shared/LottieAnimation";
import Icon from "components/shared/Icon";
import { isCurrentPathPresent } from "utils/common";

const wrapClass = "help-email";
const mainClass = `${wrapClass}-confirmation`;

const Confirmation = ({ confirmationData, pageHeader, buttons = {} }) => {
	const {
		profileData: { user },
		config: { pathsToHideUserName },
	} = useContext(Context);

	const { title, description, disclaimer, displayOwl, icon } = confirmationData;
	const { primary, secondary } = buttons;
	const isMainTitlePresent = !!pageHeader?.sections?.title;

	const confirmationTitle =
		user?.firstName && !isCurrentPathPresent(pathsToHideUserName)
			? `${title}, ${user?.firstName}`
			: `${title}`;
	const displayAnimation = displayOwl !== "false";

	return (
		<div className={wrapClass}>
			<div className={`${mainClass}`}>
				<h2
					className={`${mainClass}__title${
						isMainTitlePresent ? "" : ` ${mainClass}__title--no-header`
					}`}
				>
					{confirmationTitle}
					{icon && (
						<Icon icon={`${icon}`} className={`${mainClass}__icon--${icon}`} />
					)}
				</h2>
				{displayAnimation && (
					<LottieAnimation
						modifier="email-confirmation"
						id="confirmationAnimation"
						animation="_render_bird_email_confirmation_animation_v1.json"
						isMainTitlePresent={isMainTitlePresent}
					/>
				)}
				{description && (
					<p
						className={`${mainClass}__description`}
						dangerouslySetInnerHTML={{ __html: description }}
					/>
				)}
				<div className={`${mainClass}__button-container`}>
					<Button
						className={`${mainClass}__button ${mainClass}__button--primary`}
						link
						accessibleText={primary.ariaLabel}
						linkContent={{
							href: primary.href,
							title: primary.label,
							analyticsLinkId: primary.analyticsLinkId,
						}}
					/>
					<Button
						className={`${mainClass}__button ${mainClass}__button--secondary`}
						accessibleText={secondary.ariaLabel}
						secondary
						link
						linkContent={{
							href: secondary.href,
							title: secondary.label,
							analyticsLinkId: secondary.analyticsLinkId,
						}}
					/>
				</div>
				{disclaimer && (
					<p
						className={`${mainClass}__disclaimer`}
						dangerouslySetInnerHTML={{ __html: disclaimer }}
					/>
				)}
			</div>
		</div>
	);
};

export default Confirmation;
